/* =========================================================
   SLIDESHOW + BOTTOM NAVIGATION
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('[data-aid="slideshow"]');

    if (!slider) {
        return;
    }

    const lines = [
        ...slider.querySelectorAll('[data-name="slide-nav"]')
    ];

    function getSlides() {
        const allSlides = [
            ...slider.querySelectorAll(
                'ul[data-name="slider"] > li[data-custom-slide="true"]'
            )
        ];

        const seen = new Set();

        return allSlides.filter(function (slide) {
            const id = slide.dataset.blockId;

            if (!id || seen.has(id)) {
                return false;
            }

            seen.add(id);
            return true;
        });
    }

    const slides = getSlides();

    if (!slides.length || !lines.length) {
        return;
    }

    let currentIndex = 0;
    let isMovingByLine = false;

    /*
     * Same duration as engine-slider
     */
    const SLIDE_DURATION = 500;

    /*
     * ---------------------------------------------------------
     * UPDATE ACTIVE BOTTOM LINE
     * ---------------------------------------------------------
     */
    function setActiveLine(index) {
        index = Math.max(
            0,
            Math.min(index, lines.length - 1)
        );

        lines.forEach(function (line, i) {
            line.classList.toggle(
                'is-active',
                i === index
            );
        });

        currentIndex = index;
    }

    /*
     * ---------------------------------------------------------
     * DETECT CURRENTLY VISIBLE SLIDE
     * ---------------------------------------------------------
     *
     * We check which slide has the highest percentage of
     * visibility inside the slideshow.
     */
    function detectCurrentSlide() {
        let bestIndex = -1;
        let bestVisibility = 0;

        const sliderRect = slider.getBoundingClientRect();

        slides.forEach(function (slide, index) {
            const rect = slide.getBoundingClientRect();

            const slideWidth = rect.width;

            if (!slideWidth) {
                return;
            }

            const visibleLeft = Math.max(
                rect.left,
                sliderRect.left
            );

            const visibleRight = Math.min(
                rect.right,
                sliderRect.right
            );

            const visibleWidth = Math.max(
                0,
                visibleRight - visibleLeft
            );

            const visibility =
                visibleWidth / slideWidth;

            if (visibility > bestVisibility) {
                bestVisibility = visibility;
                bestIndex = index;
            }
        });

        /*
         * Only update when a real slide is visible.
         */
        if (
            bestIndex !== -1 &&
            bestVisibility > 0.5
        ) {
            setActiveLine(bestIndex);
        }
    }

    /*
     * ---------------------------------------------------------
     * INITIAL STATE
     * ---------------------------------------------------------
     *
     * Wait until the theme slider has initialized its transform.
     */
    setTimeout(function () {
        detectCurrentSlide();
    }, 100);

    /*
     * ---------------------------------------------------------
     * MOVE ONE SLIDE AT A TIME
     * ---------------------------------------------------------
     */
    function moveOneStep(
        direction,
        remaining,
        targetIndex
    ) {
        if (remaining <= 0) {
            setActiveLine(targetIndex);

            /*
             * Let engine-slider finish its animation
             * before detecting again.
             */
            setTimeout(function () {
                isMovingByLine = false;
                detectCurrentSlide();
            }, SLIDE_DURATION);

            return;
        }

        if (direction === 'next') {
            slider.next();
        } else {
            slider.prev();
        }

        /*
         * Wait for current animation before moving again.
         */
        setTimeout(function () {
            moveOneStep(
                direction,
                remaining - 1,
                targetIndex
            );
        }, SLIDE_DURATION + 30);
    }

    /*
     * ---------------------------------------------------------
     * BOTTOM LINE CLICK NAVIGATION
     * ---------------------------------------------------------
     */
    lines.forEach(function (line) {
        line.addEventListener(
            'click',
            function (event) {
                event.preventDefault();

                if (isMovingByLine) {
                    return;
                }

                const targetIndex = Number(
                    this.dataset.slideIndex
                );

                if (
                    Number.isNaN(targetIndex) ||
                    targetIndex < 0 ||
                    targetIndex >= slides.length
                ) {
                    return;
                }

                if (
                    targetIndex === currentIndex
                ) {
                    return;
                }

                const difference =
                    targetIndex - currentIndex;

                const direction =
                    difference > 0
                        ? 'next'
                        : 'prev';

                const steps =
                    Math.abs(difference);

                isMovingByLine = true;

                moveOneStep(
                    direction,
                    steps,
                    targetIndex
                );
            }
        );
    });

    /*
     * ---------------------------------------------------------
     * DETECT AFTER SWIPE
     * ---------------------------------------------------------
     */
    let touchEndTimer;

    function syncAfterSwipe() {
        clearTimeout(touchEndTimer);

        touchEndTimer = setTimeout(
            function () {
                detectCurrentSlide();
            },
            SLIDE_DURATION + 100
        );
    }

    slider.addEventListener(
        'touchend',
        syncAfterSwipe,
        {
            passive: true
        }
    );

    slider.addEventListener(
        'mouseup',
        syncAfterSwipe
    );

    /*
     * ---------------------------------------------------------
     * DETECT AFTER ARROW NAVIGATION
     * ---------------------------------------------------------
     */
    slider.addEventListener(
        'click',
        function (event) {
            const arrow =
                event.target.closest(
                    '[data-name="icon-next"], [data-name="icon-prev"]'
                );

            if (!arrow) {
                return;
            }

            setTimeout(
                function () {
                    detectCurrentSlide();
                },
                SLIDE_DURATION + 100
            );
        }
    );

    /*
     * ---------------------------------------------------------
     * ALSO DETECT AFTER POINTER / MOUSE DRAG
     * ---------------------------------------------------------
     */
    let pointerTimer;

    slider.addEventListener(
        'pointerup',
        function () {
            clearTimeout(pointerTimer);

            pointerTimer = setTimeout(
                function () {
                    detectCurrentSlide();
                },
                SLIDE_DURATION + 100
            );
        }
    );

    /*
     * ---------------------------------------------------------
     * WINDOW RESIZE
     * ---------------------------------------------------------
     */
    let resizeTimer;

    window.addEventListener(
        'resize',
        function () {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(
                function () {
                    detectCurrentSlide();
                },
                200
            );
        }
    );

    /*
     * ---------------------------------------------------------
     * ACTIVE LINE ANIMATION
     * ---------------------------------------------------------
     */
    lines.forEach(function (line) {
        line.style.transition =
            'background-color 0.5s cubic-bezier(0.22, 1, 0.36, 1), ' +
            'opacity 0.5s cubic-bezier(0.22, 1, 0.36, 1), ' +
            'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
    });
});


/* =========================================================
   VIEW MORE / VIEW LESS COLLECTION PRODUCTS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
    const viewMoreButtons =
        document.querySelectorAll(
            '[data-view-more]'
        );

    viewMoreButtons.forEach(function (button) {
        const collectionGrid =
            button.closest('collection-grid');

        if (!collectionGrid) {
            return;
        }

        const products = Array.from(
            collectionGrid.querySelectorAll(
                '.collection-product-item'
            )
        );

        if (!products.length) {
            return;
        }

        const step =
            parseInt(
                button.dataset.step,
                10
            ) || 8;

        const viewMoreText =
            button.dataset.viewMoreText ||
            'View More';

        const viewLessText =
            button.dataset.viewLessText ||
            'View Less';

        const total = products.length;

        let visibleCount =
            Math.min(
                step,
                total
            );

        let isAnimating = false;

        /*
         * -----------------------------------------------------
         * INITIAL PRODUCTS
         * -----------------------------------------------------
         */
        products.forEach(
            function (product, index) {
                if (index < visibleCount) {
                    product.classList.remove(
                        'hidden'
                    );
                } else {
                    product.classList.add(
                        'hidden'
                    );
                }
            }
        );

        /*
         * -----------------------------------------------------
         * UPDATE BUTTON TEXT
         * -----------------------------------------------------
         */
        function updateButton() {
            if (visibleCount >= total) {
                button.textContent =
                    viewLessText;

                button.setAttribute(
                    'aria-label',
                    viewLessText
                );
            } else {
                button.textContent =
                    viewMoreText;

                button.setAttribute(
                    'aria-label',
                    viewMoreText
                );
            }
        }

        updateButton();

        /*
         * -----------------------------------------------------
         * BUTTON CLICK
         * -----------------------------------------------------
         */
        button.addEventListener(
            'click',
            function () {
                if (isAnimating) {
                    return;
                }

                isAnimating = true;

                /*
                 * =============================================
                 * VIEW MORE
                 * =============================================
                 */
                if (visibleCount < total) {
                    const oldVisibleCount =
                        visibleCount;

                    const newVisibleCount =
                        Math.min(
                            visibleCount + step,
                            total
                        );

                    const newProducts =
                        products.slice(
                            oldVisibleCount,
                            newVisibleCount
                        );

                    /*
                     * Remember first newly
                     * visible product.
                     */
                    const firstProduct =
                        newProducts[0];

                    /*
                     * Show new products.
                     */
                    newProducts.forEach(
                        function (product) {
                            product.classList.remove(
                                'hidden'
                            );

                            product.classList.add(
                                'product-enter'
                            );
                        }
                    );

                    /*
                     * Wait for browser to calculate
                     * the new layout.
                     */
                    requestAnimationFrame(
                        function () {
                            requestAnimationFrame(
                                function () {
                                    newProducts.forEach(
                                        function (
                                            product
                                        ) {
                                            product.classList.remove(
                                                'product-enter'
                                            );
                                        }
                                    );

                                    visibleCount =
                                        newVisibleCount;

                                    updateButton();

                                    /*
                                     * Scroll to the first
                                     * newly revealed product.
                                     */
                                    if (firstProduct) {
                                        const productTop =
                                            firstProduct.getBoundingClientRect().top +
                                            window.pageYOffset;

                                        const offset =
                                            100;

                                        window.scrollTo({
                                            top:
                                                productTop -
                                                offset,
                                            behavior:
                                                'smooth'
                                        });
                                    }

                                    setTimeout(
                                        function () {
                                            isAnimating =
                                                false;
                                        },
                                        2200
                                    );
                                }
                            );
                        }
                    );

                /*
                 * =============================================
                 * VIEW LESS
                 * =============================================
                 */
                } else {
                    const oldVisibleCount =
                        visibleCount;

                    const newVisibleCount =
                        Math.max(
                            visibleCount - step,
                            step
                        );

                    const productsToHide =
                        products.slice(
                            newVisibleCount,
                            oldVisibleCount
                        );

                    /*
                     * Start exit animation.
                     */
                    productsToHide.forEach(
                        function (product) {
                            product.classList.add(
                                'product-exit'
                            );
                        }
                    );

                    /*
                     * Wait for animation.
                     */
                    setTimeout(
                        function () {
                            productsToHide.forEach(
                                function (
                                    product
                                ) {
                                    product.classList.add(
                                        'hidden'
                                    );

                                    product.classList.remove(
                                        'product-exit'
                                    );
                                }
                            );

                            visibleCount =
                                newVisibleCount;

                            updateButton();

                            isAnimating =
                                false;
                        },
                        700
                    );
                }
            }
        );
    });
});